module.exports = {"id":"161636","name":"Néstor Ortigoza","rating":"74","photo":"./data/images/photos/4/161636.png","club":{"name":"Rosario Central","logo":"./data/images/clubs/RosarioCentral.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NestorOrtigoza0.json
// module id = 3172
// module chunks = 0